import React, { useEffect } from 'react'
import { Tooltip, ToastContainer, Loading } from 'mailup-web-components'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import ModalConfirmLeave from 'Components/ModalConfirmLeave'
import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import { useIntl } from 'react-intl'
import { pageState } from './recoil/state/state'
import Header from './components/Header'
import { initCallback, resetCallback } from './recoil/callbacks/callbacks'
import State from './components/State'
import Button from './components/Button/Button'
import Paragraph from './components/Paragraph/Paragraph'
import Social from './components/Social/Social'
import Footer from './components/Footer'
import useBeforeUnload from 'Hooks/useRouteBeforeUnload'

const EmailContentDefaults = () => {
  const { loaded, loading, error, severity, isDirty } = useRecoilValue(
    pageState
  )
  const init = useRecoilCallback(initCallback, [])
  const reset = useRecoilCallback(resetCallback, [])
  useBeforeUnload(isDirty)
  useEffect(() => {
    init()
    return () => {
      reset()
    }
  }, [])

  return (
    <>
      <Header />
      <Tooltip />
      <ToastContainer />
      <Loading open={loading} />
      <ModalConfirmLeave />
      <PageContainer>
        <ErrorFeedback
          error={error}
          severity={severity}
          onClickReload={() => init()}
        />
        {!error && loaded && (
          <>
            <State />
            <Paragraph />
            <Button />
            <Social />
            <Footer />
          </>
        )}
      </PageContainer>
    </>
  )
}

export default EmailContentDefaults
